import "../../css/article.scss";
import React from "react";
import ReactPlayer from "react-player/youtube";
import PropTypes from "prop-types";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const Article = ({ article }) => {
  const hasNumber = article.number?.length > 0;
  const hasText = article.text?.length > 0;
  const hasVideo = article.video?.length > 0;

  return (
    <>
      <h1 className="article-title">{article.title}</h1>

      {hasText && (
        <div className="article-page">
          <p
            style={{ whiteSpace: "pre-wrap" }}
            dangerouslySetInnerHTML={{ __html: article.text }}
            className="content-div"
          />
        </div>
      )}
      {hasNumber && (
        <>
          <div className="article-pdf">
            <Document
              file="https://www.michigandaily.com/wp-content/uploads/2022/07/2022-Orientation-Guide.pdf"
              onLoadError={console.error}
            >
              {article.number.map((d) => (
                <Page
                  key={d.pageNumber}
                  pageNumber={parseInt(d.pageNumber, 10)}
                />
              ))}
            </Document>
          </div>
          <div className="center-button">
            <a
              href="https://issuu.com/michigandaily/docs/2022_orientation_guide"
              target="_blank"
              rel="noreferrer"
            >
              <button type="button" className="article-button">
                Read Article on Issuu
              </button>
            </a>
          </div>
        </>
      )}
      {hasVideo && (
        <div className="video">
          <ReactPlayer url={article.video} />
        </div>
      )}
    </>
  );
};

Article.propTypes = {
  article: PropTypes.shape({
    description: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    text: PropTypes.string,
    number: PropTypes.arrayOf(
      PropTypes.shape({
        pageNumber: PropTypes.string.isRequired,
      })
    ),
    video: PropTypes.string,
  }).isRequired,
};

export default Article;
